import { Badge } from "@loot-os/ui/components/badge";

/**
 * One fraud verdict: SEON's approve / review / decline, or "SEON unavailable" when the vendor
 * could not be asked and the flow proceeded as review by policy.
 */
export function FraudStateBadge({
  state,
  source,
  title,
}: {
  state: string;
  source?: string;
  title?: string;
}) {
  if (source === "unavailable") {
    return (
      <Badge variant="outline" title={title ?? "SEON did not answer; treated as review."}>
        SEON unavailable
      </Badge>
    );
  }
  const variant =
    state === "decline" ? "destructive" : state === "review" ? "secondary" : "outline";
  return (
    <Badge variant={variant} title={title}>
      {state}
    </Badge>
  );
}
